import React from "react";

const ReadOnlyRow = ({
  isLoadingDelete,
  contact,
  handleEditClick,
  handleDeleteClick,
}) => {
  return (
     <tr className="trrows hover-red bg-white ">
      <td className="bg-gold">{contact.id}</td>
      <td>{contact.farmerid}</td>
      <td>{contact.username}</td>
      <td>{contact.email}</td>
      <td>{contact.password}</td>
      <td>{contact.phone}</td>
      <td>{contact.joined}</td>
      <td>{contact.company}</td>

      <td>{contact.lastactive}</td>
      <td>{contact.category}</td>
      <td>{contact.status}</td>

      <td>

          <label className="pa4 hover-bg-transparent"onClick={(event) => handleEditClick(event, contact)}>
            <i className="fas fa-edit f2 hover-gold"></i>
            <span className="ml2"></span>
          </label>
   
    
         
         <label className="pa4 hover-bg-transparent"  onClick={() => handleDeleteClick(contact.id)}>
            <i className="fas fa-trash f2 hover-yellow red"></i>
            <span className="ml2"></span>
          </label>
      </td>
    </tr>
  );
};

export default ReadOnlyRow;
